export class NeoParametrizacionLineaDTO {
  constructor(
    public idParametrizacionLinea: Number,
    public estado: string,
    public nombre: string,
    public periodoGraciaMaximo: Number,
    public periodoGraciaMinimo: Number,
    public plazoMaximo: Number,
    public plazoMinimo: Number,
    public fechaRegistro: Date,
    public idCliente_NeoCliente: Number,
    public idNombreLineasCredito: Number,
  ) {}
}
